import { render } from "./InvestOverview.vue?vue&type=template&id=40f5cc76&scoped=true"
import script from "./InvestOverview.vue?vue&type=script&lang=js"
export * from "./InvestOverview.vue?vue&type=script&lang=js"

import "./InvestOverview.vue?vue&type=style&index=0&id=40f5cc76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f5cc76"]])

export default __exports__